import { BUDBEE, INSTABOX, PORTERBUDDY } from './brand-enum'
import { getUrlEnvironmentSegment } from './service-url'

/**
 * Validates the brand and returns a default value if the brand is not valid.
 *
 * @param {*} brand
 * @returns {'BUDBEE' | 'INSTABOX' | 'PORTERBUDDY'} The validated brand.
 */
export function validationBrand(value) {
    let brand = value

    if (typeof value !== 'string' || !value) {
        return BUDBEE
    }

    brand = value.toUpperCase()

    if (![BUDBEE, PORTERBUDDY, INSTABOX].includes(brand)) {
        return BUDBEE
    }

    return brand
}

/**
 * Gets the environment segment of the URL.
 *
 * @returns {'testing' | ''} The environment segment of the URL.
 */
export function getTrackingLinkEnvironment() {
    const environment = getUrlEnvironmentSegment()

    // It means that we are in localhost
    if (environment === null) {
        return 'testing'
    }

    return environment.replace(/\./g, '')
}

/**
 * Gets the tracking link for the specified brand.
 *
 * @typedef {'.testing' | ''} Environment
 * @typedef {`tracking${Environment}.budbee.com` | `track${Environment}.porterbuddy.com`  | `tracking${Environment}.instabee.com`} TrackingLink
 *
 * @param {{ brand: 'BUDBEE' | 'INSTABOX' | 'PORTERBUDDY', token: string, authParam: string }} param0
 * @returns {`https://${TrackingLink}.com/${token}?auth=${authParam}`} The tracking link.
 */
export function createTrackingLink({ brand, token, authParam }) {
    const urlSegments = {
        [BUDBEE]: ['tracking', 'budbee'],
        [INSTABOX]: ['tracking', 'instabee'],
        [PORTERBUDDY]: ['track', 'porterbuddy'],
    }

    const validatedBrand = validationBrand(brand)
    const urlSegment = urlSegments[validatedBrand]
    const environment = getTrackingLinkEnvironment()

    if (environment) {
        urlSegment.splice(1, 0, environment)
    }

    const baseUrl = urlSegment.join('.')

    return `https://${baseUrl}.com/${token}?auth=${authParam}`
}
